import Bloc from './Bloc.js';
import Types from './Types.js';

export default class LoseLife extends Bloc {

	constructor (src, ctx) {

		super("lifeloss", src, ctx, true);
		this.f = (src, ins) => {
			if (ins[0]?.removedFromFight || (ins[0]?.id?.type === "enemy" && ins[0]?.dead && ins[0]?.removed))
				return [];
			ins[0].loseLife(ins[2]);
			return [];
		};
		this.types = [Types.entity, Types.entity, Types.int];
	}
}
